/** Тексты пространства «face». Ключи именуются по смыслу, а не по месту. */
export const face = {
  title: 'База внешек',

  screen: {
    create: 'Новая внешка',
    edit: 'Правка внешки',
  },

  search: {
    placeholder: 'Имя внешки',
    clear: 'Очистить поиск',
  },

  action: {
    create: 'Завести',
    edit: 'Править',
    delete: 'Удалить',
    openCard: 'Открыть внешку: {{name}}',
  },

  loading: {
    list: 'Листаем справочник',
    card: 'Открываем карточку',
  },

  empty: {
    notFound: 'Никого не нашли',
    notFoundHint: 'Попробуйте другое написание имени.',
    list: 'Справочник пуст',
    /** Пусто у того, кто может завести карточку, и у того, кто не может. */
    listHintEditor: 'Заполнять базу внешек может модератор анкет — начните с первой карточки.',
    listHint: 'Карточки появятся, когда модераторы перенесут сюда базу сообщества.',
    card: 'В карточке пока только имя.',
  },

  error: {
    noFace: 'Такой внешки не существует',
    cardFailed: 'Карточка не открылась',
    nameRequired: 'Без имени карточку не найти',
  },

  card: {
    caption: 'внешка · {{doc}}',
    hasLink: 'есть ссылка на источник',
    staff: 'Персонал',
  },

  saved: {
    created: 'Внешка «{{name}}» добавлена',
    updated: 'Изменения сохранены',
  },

  remove: {
    confirm: 'Удалить «{{name}}»? Карточка исчезнет насовсем.',
  },

  section: {
    photo: 'Фото',
    record: 'Запись',
  },

  field: {
    photo: 'Фото внешки',
    name: 'Имя',
    link: 'Ссылка',
  },

  placeholder: {
    name: 'Например, Тильда Суинтон',
  },

  hint: {
    link: 'Куда посмотреть: фотосет, страница актёра, доска',
    note: 'Видна всем: чем внешка примечательна, что стоит учесть',
    uploadClosed: 'Загрузка файлов закрыта: аккаунту оставлено только чтение.',
  },
} as const;
